var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "pega-login-container grid-y" }, [
    _c("div", { staticClass: "cell" }, [
      _c("div", { staticClass: "grid-x align-center" }, [
        _c(
          "div",
          { staticClass: "cell large-5 medium-8 small-10 pega-login-content" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.login.apply(null, arguments)
                  },
                },
              },
              [
                _c("p", { staticClass: "margin-0 pega-font-size-min-rem" }, [
                  _vm._v("\n            ログインID\n          "),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-group" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.loginId,
                          expression: "loginId",
                        },
                      ],
                      class: {
                        "is-invalid-input login-form-error":
                          _vm.isInvalidLoginId,
                      },
                      attrs: {
                        id: "loginId",
                        name: "loginId",
                        "data-test": "login-id",
                        type: "text",
                        placeholder: "ログインID",
                      },
                      domProps: { value: _vm.loginId },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.loginId = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.isInvalidLoginId
                      ? _c("validation-label", {
                          staticClass: "login-form-error",
                          attrs: {
                            label:
                              "ログインIDが誤っています。（メールアドレスではありませんのでご注意ください）",
                            "data-test": "login-id-validation",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "margin-0 pega-font-size-min-rem" }, [
                  _vm._v("\n            パスワード\n          "),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.loginPassword,
                        expression: "loginPassword",
                      },
                    ],
                    attrs: {
                      id: "loginPassword",
                      name: "loginPassword",
                      "data-test": "login-password",
                      type: "password",
                      placeholder: "パスワード",
                    },
                    domProps: { value: _vm.loginPassword },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.loginPassword = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "float-center boss-button-center pega-login-button pega-button",
                    attrs: {
                      disabled: _vm.isDisable,
                      "data-test": "login-button",
                      type: "submit",
                    },
                  },
                  [_vm._v("\n            ログイン\n          ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "margin-top-2 text-center" }, [
                  _c(
                    "a",
                    {
                      staticClass: "pega-login-help-link",
                      attrs: {
                        href: "/help/faq/002.html",
                        target: "_blank",
                        "data-test": "link-help",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v("＞ID・パスワードをお忘れの方はこちら"),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "text-center" }, [
      _c("div", { staticClass: "font-bold" }, [
        _vm._v("\n            正社員で長く働きたい女性のための転職サイト "),
        _c("span", { staticClass: "text-nowrap" }, [
          _vm._v("【女の転職タイプ】"),
        ]),
      ]),
      _vm._v(" "),
      _c("img", {
        staticClass: "pega-logo margin-bottom-2",
        attrs: { src: require("@/assets/images/uki-logo.png") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }